// extracted by mini-css-extract-plugin
export var blue = "_1p-h";
export var brand = "_1p-d";
export var darkGrey = "_1p-g";
export var disabled = "_1p-6";
export var disabledSubtle = "_1p-7";
export var error = "_1p-8";
export var green = "_1p-i";
export var grey = "_1p-f";
export var icon = "_1p-0";
export var inherit = "_1p-c";
export var lightGrey = "_1p-e";
export var orange = "_1p-k";
export var pink = "_1p-m";
export var primary = "_1p-1";
export var purple = "_1p-n";
export var quaternary = "_1p-4";
export var quinary = "_1p-5";
export var red = "_1p-l";
export var secondary = "_1p-2";
export var success = "_1p-b";
export var tertiary = "_1p-3";
export var warning = "_1p-9";
export var warningSecondary = "_1p-a";
export var white = "_1p-o";
export var yellow = "_1p-j";